import styled from "styled-components";

const Container = styled.div``;

const Button = styled.button`
  border: none;
  width: 100%;
  height: 40px;
  background-color: #0540C5;
`;
const TextButton = styled.span`
  border: none;
  width: 100%;
  height: 40px;
  color: #fff;
`;
export { Container, Button, TextButton };
